import React from "react";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import {
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";

import PropTypes from "prop-types";
import SaveTemplateButton from "./SaveTemplateButton/SaveTemplateButton";
import ExportCsvButton from "./ExportCsvButton/ExportCsvButton";
import QuickFilter from "./QuickFilter/QuickFilter";
import toolbarButtonStyle from "./toolbarButtonStyle";

/**
 * Custom Flow toolbar component for Mui DataGrid
 * @param {function} clickOnTemplateCreation This function called when the Save Search button pressed
 * @return {JSX.Element}
 */
const Toolbar = ({
    clickOnTemplateCreation,
    hideExportButton,
    additionalElements,
    saveSearchTemplateButtonLabel,
    saveSearchTemplateButtonProps,
}) => {
    return (
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={3}
            sx={{ py: 2 }}
        >
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
            >
                <Grid>
                    <QuickFilter />
                </Grid>

                <Grid>
                    <GridToolbarFilterButton
                        slotProps={{
                            button: {
                                sx: toolbarButtonStyle,
                                id: "btnGridFilter",
                            },
                        }}
                    />
                </Grid>

                <Grid>
                    <GridToolbarColumnsButton
                        slotProps={{
                            button: {
                                sx: toolbarButtonStyle,
                                id: "btnGridColumns",
                            },
                        }}
                    />
                </Grid>

                {additionalElements?.map((Component, index) => (
                    <Grid key={`additionalToolbarElement_${index}`}>
                        {Component}
                    </Grid>
                ))}
            </Grid>

            <Grid>
                <Stack direction="row" spacing={3}>
                    {!hideExportButton && <ExportCsvButton />}

                    {clickOnTemplateCreation && (
                        <SaveTemplateButton
                            clickOnTemplateCreation={clickOnTemplateCreation}
                            saveSearchTemplateButtonLabel={
                                saveSearchTemplateButtonLabel
                            }
                            tooltip={saveSearchTemplateButtonProps?.tooltip}
                            {...saveSearchTemplateButtonProps}
                        />
                    )}
                </Stack>
            </Grid>
        </Grid>
    );
};

Toolbar.propTypes = {
    clickOnTemplateCreation: PropTypes.func,
    hideExportButton: PropTypes.bool,
    additionalElements: PropTypes.arrayOf(PropTypes.node),
    saveSearchTemplateButtonLabel: PropTypes.string,
    saveSearchTemplateButtonProps: PropTypes.object,
};

export default Toolbar;
